import { render, staticRenderFns } from "./opportunityManage.vue?vue&type=template&id=adba4b1a&scoped=true"
import script from "./opportunityManage.vue?vue&type=script&lang=js"
export * from "./opportunityManage.vue?vue&type=script&lang=js"
import style0 from "./opportunityManage.vue?vue&type=style&index=0&id=adba4b1a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adba4b1a",
  null
  
)

export default component.exports